/* eslint-disable @typescript-eslint/no-explicit-any */
import { alphabetGenerator } from 'utilities/alphabet-utilities';
import {
  DISCOUNT_FOR_LACK_OF_MARKETABILITY_ALIAS,
  EQUITY_ALLOCATION_SUMMARY_ALIAS,
  LESS_DEBT_ALIAS,
  TABLE_SECOND_TITLE,
  TABLE_TITLE,
  VALUE_PER_COMMON_SHARE_ALIAS,
  WEIGHTED_ENTERPRISE_MARKET_VALUE_ALIAS,
} from './rowConfig';
import { ValuationMethodParserParams } from './types';

const editableRowsAlias = [
  LESS_DEBT_ALIAS,
  WEIGHTED_ENTERPRISE_MARKET_VALUE_ALIAS,
  VALUE_PER_COMMON_SHARE_ALIAS,
  DISCOUNT_FOR_LACK_OF_MARKETABILITY_ALIAS,
];

const parser = async (props: ValuationMethodParserParams) => {
  const { columns, rowConfig, tableData } = props;
  const { editMode } = tableData;
  let cells = {};
  const alphabet = alphabetGenerator([], columns.length);
  if (Array.isArray(rowConfig)) {
    rowConfig.forEach((row: any, rowIdx: any) => {
      columns.forEach((col: any, colIdx: any) => {
        const rowNumber = rowIdx + 1;
        const columnLegend = alphabet[colIdx];
        const key = columnLegend + rowNumber;
        let value = rowNumber === 1 || row.alias === TABLE_TITLE ? TABLE_SECOND_TITLE : col[row.alias];
        let readOnly = true;

        if (row.alias === EQUITY_ALLOCATION_SUMMARY_ALIAS) {
          value = '';
        }
        if (editableRowsAlias.includes(row.alias) && editMode) {
          readOnly = false;
        }

        cells = {
          ...cells,
          [key]: {
            ...row,
            key,
            rowSpan: 1,
            columnLegend,
            readOnly,
            value,
          },
        };
      });
    });
  }

  return cells;
};

export default parser;
